const context = 'orders'

export const FETCH_REFUND_ORDERS = `${context}/FETCH_REFUND_ORDERS`

export const REFUND_ORDER = `${context}/REFUND_ORDER`

export const CLEAR_ORDERS = `${context}/CLEAR_ORDERS`

export const FETCH_ALL_ORDERS_REQUESTED = `${context}/FETCH_ALL_ORDERS_REQUESTED`
export const FETCH_ALL_ORDERS_SUCCEDED = `${context}/FETCH_ALL_ORDERS_SUCCEDED`
export const FETCH_ALL_ORDERS_FAILED = `${context}/FETCH_ALL_ORDERS_FAILED`

export const SET_ALL_ORDERS_FILTERS = `${context}/SET_ALL_ORDERS_FILTERS`
export const SET_ORDERS_API_PARAMS_CONFIG = 'SET_ORDERS_API_PARAMS_CONFIG'

export const FETCH_REFUND_ORDERS_REQUESTED = 'FETCH_REFUND_ORDERS_REQUESTED'
export const FETCH_REFUND_ORDERS_SUCCEDED = 'FETCH_REFUND_ORDERS_SUCCEDED'
export const FETCH_REFUND_ORDERS_FAILED = 'FETCH_REFUND_ORDERS_FAILED'

export const REFUND_ORDER_REQUESTED = 'REFUND_ORDER_REQUESTED'
export const REFUND_ORDER_SUCCEEDED = 'REFUND_ORDER_SUCCEEDED'
export const REFUND_ORDER_FAILED = 'REFUND_ORDER_FAILED'

export const SET_REFUND_ORDERS_FILTERS = ' SET_REFUND_ORDERS_FILTERS'
